import script from "./OrdersIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersIcon.vue?vue&type=script&setup=true&lang=js"

import "./OrdersIcon.vue?vue&type=style&index=0&id=7be8703b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be8703b"]])

export default __exports__